<button mat-button class="fn-ui-close-icon" automation-id="fn-ui-close-icon" [disabled]="disabled" (click)="onCloseClick()">
    <app-fn-ui-icon icon="close" [size]="size"></app-fn-ui-icon>
</button>